import React from "react";

const Users = () => {
  return (
    <div className="users">
      <h1>Users</h1>
    </div>
  );
};

export default Users;
